import { UUID } from "crypto";

import { Company } from "@interfaces/companies";
import { ApplicationMarketplaceSelected, ApplicationSelected } from "@interfaces/slices";
import { BpmUser, Permission, PermissionV2 } from "@interfaces/users";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationMarketplaceResume, ApplicationResume } from "@interfaces/application";
import { FinancialCompany } from "@interfaces/catalogs";

export interface AppSlice {
    applicationSelected: ApplicationSelected | ApplicationMarketplaceSelected;
    session: {
        user: BpmUser;
        companies: Array<Company>;
        permissions: Array<Permission>;
        permissionsV2: Array<PermissionV2>;
        financial_inc: Array<FinancialCompany>;
        // {
        //     id: UUID;
        //     code: string;
        // };
        recovery: {
            username: string;
        };
        source_codes: Array<string>;
    };
    validateFileModal: {
        show: boolean;
    };
}

const initialState: AppSlice = {
    applicationSelected: {
        id: "0-0-0-0-0",
        id_application: 0,
        company_name: "",
        comercial_name: "",
        company_rfc: "",
        user_name: "",
        user_email: "",
        requested_amount: 0,
        requested_term: 0,
        approved_amount: 0,
        approved_term: 0,
        approved_min_term: 0,
        approved_max_term: 0,
        screen_time_seconds: 0,
        total_time_seconds: 0,
        client_total_time_seconds: 0,
        last_status_date: "",
        stage_name: "",
        substage_name: "",
        status_name: "",
        status_code: "",
        channel: "",
        channel_id: "",
        detail_channel: "",
        macrochannel: "",
        assigned_partner: "",
        assigned_partner_email: "",
        interested: false,
        msol_total_comments: 0,
        mrev_total_comments: 0,
        mpin_total_comments: 0,
        mrec_total_comments: 0,
        maut_total_comments: 0,
        mcli_total_comments: 0,
        authorized: false,
        credit_validated: false,
        pld_validated: false,
        legal_incidents_validated: false,
        client_detail_id: "0-0-0-0-0",
        stage: {
            id: "0-0-0-0-0",
            name: "",
            description: "",
        },
        substage: {
            id: "0-0-0-0-0",
            name: "",
            description: "",
            stage_id: "0-0-0-0-0",
        },
        status: {
            id: "0-0-0-0-0",
            name: "",
            description: "",
            substage_id: "0-0-0-0-0",
            code: "",
        },
        tax_system: {
            id: "0-0-0-0-0",
            name: "",
            code: "",
            product_id: "0-0-0-0-0",
            tax_system_type: "",
            application_code: "",
        },
        accept: null,
        declined: null,
        financial_company_id: "0-0-0-0-0",
        financial_company: {
            id: "0-0-0-0-0",
            code: "",
            name: "",
            logo: "",
            description: "",
            contact_name: "",
            contact_email: "",
            offer_config: {
                authorizedFee: 0,
                openingFee: 0,
                validity: {
                    options: [],
                    type: "",
                },
            },
            active: false,
        },
        dictamenCompletado: false,
        company_docs_validated: false,
        shareholder_docs_validated: false,
        owners_docs_validated: false,
        existsSDC: false,
        visit_analysis_validated: null,
        check_control_validated: null,
        disburment_date: "",
        product_id: "0-0-0-0-0",
        financed_service_code: "",
        guarantee_type_code: "",
        company_source: "",
        id_application_company: 0,
        company_id: "0-0-0-0-0",
    },
    session: {
        user: {
            id: "0-0-0-0-0",
            name: "",
            last_name: "",
            last_name_2: "",
            rol_id: "0-0-0-0-0",
            created_at: "",
            updated_at: "",
            role: {
                id: "0-0-0-0-0",
                name: "",
                code: "",
            },
            sso_id: "0-0-0-0-0",
            status: "ACTIVE",
            email: "",
            company_id: "0-0-0-0-0",
            last_login_at: "",
            companies: [],
            financials: [],
            preferences: {
                theme: "light",
                avatar: {
                    color: "#FFF",
                    initials: "",
                },
                sessionOptions: {
                    persist: false,
                    durationDays: 15,
                },
            },
            user_parent_id: "0-0-0-0-0",
        },
        permissions: [],
        permissionsV2: [],
        recovery: {
            username: "",
        },
        companies: [],
        source_codes: [],
        financial_inc: [],
    },
    validateFileModal: {
        show: false,
    },
};

export const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        // setApplicationSelected: (state, action: PayloadAction<ApplicationResume>) => {
        //     state.applicationSelected = {
        //         ...action.payload,
        //         dictamenCompletado: false,
        //         company_docs_validated: false,
        //         shareholder_docs_validated: false,
        //         owners_docs_validated: false,
        //         existsSDC: false,
        //         credit_validated: null,
        //         pld_validated: null,
        //         legal_incidents_validated: null,
        //         visit_analysis_validated: null,
        //         check_control_validated: null,
        //     };
        // },
        setApplicationSelected: {
            reducer: (state, action: PayloadAction<ApplicationResume | ApplicationMarketplaceResume>) => {
                state.applicationSelected = {
                    ...action.payload,
                    dictamenCompletado: false,
                    company_docs_validated: false,
                    shareholder_docs_validated: false,
                    owners_docs_validated: false,
                    existsSDC: false,
                    // credit_validated: null,
                    // pld_validated: null,
                    // legal_incidents_validated: null,
                    visit_analysis_validated: null,
                    check_control_validated: null,
                };
            },
            prepare: (
                payload: ApplicationResume | ApplicationMarketplaceResume = {
                    id: "0-0-0-0-0",
                    id_application: 0,
                    company_name: "",
                    comercial_name: "",
                    company_rfc: "",
                    user_name: "",
                    user_email: "",
                    requested_amount: 0,
                    requested_term: 0,
                    approved_amount: 0,
                    approved_term: 0,
                    approved_min_term: 0,
                    approved_max_term: 0,
                    screen_time_seconds: 0,
                    total_time_seconds: 0,
                    client_total_time_seconds: 0,
                    last_status_date: "",
                    stage_name: "",
                    substage_name: "",
                    status_name: "",
                    status_code: "",
                    channel: "",
                    channel_id: "",
                    detail_channel: "",
                    macrochannel: "",
                    assigned_partner: "",
                    assigned_partner_email: "",
                    interested: false,
                    disburment_date: "",
                    msol_total_comments: 0,
                    mrev_total_comments: 0,
                    mpin_total_comments: 0,
                    mrec_total_comments: 0,
                    maut_total_comments: 0,
                    mcli_total_comments: 0,
                    authorized: false,
                    credit_validated: false,
                    legal_incidents_validated: false,
                    pld_validated: false,
                    financed_service_code: "",
                    guarantee_type_code: "",
                    company_source: "",
                    client_detail_id: "0-0-0-0-0",
                    product_id: "0-0-0-0-0",
                    accept: null,
                    declined: null,
                    financial_company_id: "0-0-0-0-0",
                    financial_company: {
                        id: "0-0-0-0-0",
                        code: "",
                        name: "",
                        logo: "",
                        description: "",
                        contact_name: "",
                        contact_email: "",
                        offer_config: {
                            authorizedFee: 0,
                            openingFee: 0,
                            validity: {
                                type: "",
                                options: [],
                            },
                        },
                        active: false,
                    },
                    stage: {
                        id: "0-0-0-0-0",
                        name: "",
                        description: "",
                    },
                    substage: {
                        id: "0-0-0-0-0",
                        name: "",
                        description: "",
                        stage_id: "0-0-0-0-0",
                    },
                    status: {
                        id: "0-0-0-0-0",
                        name: "",
                        description: "",
                        substage_id: "0-0-0-0-0",
                        code: "",
                    },
                    tax_system: {
                        id: "0-0-0-0-0",
                        name: "",
                        code: "",
                        product_id: "0-0-0-0-0",
                        tax_system_type: "",
                        application_code: "",
                    },
                    id_application_company: 0,
                    company_id: "0-0-0-0-0",
                },
            ) => {
                return {
                    payload: payload,
                };
            },
        },
        setCleanApplicationSelected: (state) => {
            state.applicationSelected = initialState.applicationSelected;
        },
        setApplicationCompleted: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.dictamenCompletado = action.payload;
        },
        // setApplicationState: (state, action: PayloadAction<{ code: string; estatus: string; statusId: UUID }>) => {
        //   state.applicationSelected.statusId = action.payload.statusId;
        //   state.applicationSelected.status_code = action.payload.code;
        //   state.applicationSelected.estatus = action.payload.estatus;
        // },
        setApplicationStateCode: (state, action: PayloadAction<string>) => {
            state.applicationSelected.status_code = action.payload;
        },
        setBpmUserLogged: (state, action: PayloadAction<BpmUser>) => {
            state.session.user = action.payload;
        },
        setUserPermissions: (state, action: PayloadAction<Array<Permission>>) => {
            state.session.permissions = action.payload;
        },
        setUserPermissionV2: (state, action: PayloadAction<Array<PermissionV2>>) => {
            state.session.permissionsV2 = action.payload;
        },
        setCompaniesAssigned: (state, action: PayloadAction<Array<Company>>) => {
            state.session.companies = action.payload;
        },
        setSourceCodesAssigned: (state, action: PayloadAction<Array<string>>) => {
            state.session.source_codes = action.payload;
        },
        setFinancialIncAssigned: (state, action: PayloadAction<Array<FinancialCompany>>) => {
            state.session.financial_inc = action.payload;
        },
        setCompanyDocsValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.company_docs_validated = action.payload;
        },
        setShareHolderDocsValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.shareholder_docs_validated = action.payload;
        },
        setOwnersDocsValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.owners_docs_validated = action.payload;
        },
        setShowValidateFileModal: (state, action: PayloadAction<boolean>) => {
            state.validateFileModal.show = action.payload;
        },
        setRecoveryUsername: (state, action: PayloadAction<string>) => {
            state.session.recovery.username = action.payload;
        },
        setExistSDC: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.existsSDC = action.payload;
        },
        setApplicationCreditValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.credit_validated = action.payload;
        },
        setApplicationPldValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.pld_validated = action.payload;
        },
        setApplicationLegalIncidentValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.legal_incidents_validated = action.payload;
        },
        setApplicationVisitAnalysisValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.visit_analysis_validated = action.payload;
        },
        setApplicationCheckControlValidated: (state, action: PayloadAction<boolean>) => {
            state.applicationSelected.check_control_validated = action.payload;
        },
        setApplicationCanalIdUpdated: (state, action: PayloadAction<string>) => {
            state.applicationSelected.channel_id = action.payload;
        },
        setApplicationGuaranteeTypeChanged: (state, action: PayloadAction<string>) => {
            state.applicationSelected.guarantee_type_code = action.payload;
        },
    },
});

export const {
    setCleanApplicationSelected,
    setApplicationSelected,
    setApplicationCompleted,
    //   setApplicationState,
    setApplicationStateCode,
    setBpmUserLogged,
    setUserPermissions,
    setUserPermissionV2,
    setCompaniesAssigned,
    setSourceCodesAssigned,
    setFinancialIncAssigned,
    setCompanyDocsValidated,
    setShareHolderDocsValidated,
    setOwnersDocsValidated,
    setShowValidateFileModal,
    setRecoveryUsername,
    setExistSDC,
    setApplicationCreditValidated,
    setApplicationPldValidated,
    setApplicationLegalIncidentValidated,
    setApplicationVisitAnalysisValidated,
    setApplicationCheckControlValidated,
    setApplicationCanalIdUpdated,
    setApplicationGuaranteeTypeChanged,
} = appSlice.actions;
export default appSlice.reducer;
